import React, { useEffect, useState } from 'react';
import {
  InputNumber100Px,
  LabelFieldWrapper,
  TextWithTooltip,
} from './asoSettingsStyledComponents';
import { Column, TextProps } from '@ydistri/ds';
import AsoTooltip, { AsoTooltipKey } from '../../AsoTooltip';

type AsoNumericFieldStatus = 'error' | 'warning';

interface AsoNumericFieldRowProps {
  label: string;
  labelWidth?: TextProps['$width'];
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  postfix?: React.ReactNode;
  precision?: number;
  min?: number;
  max?: number;
  step?: number;
  status?: AsoNumericFieldStatus;
  feedback?: React.ReactNode;
  tooltipKey?: AsoTooltipKey;
}

export const AsoNumericFieldRow: React.FC<AsoNumericFieldRowProps> = ({
  label,
  labelWidth = '15rem',
  value,
  onChange,
  postfix = null,
  precision = 0,
  min,
  max,
  step,
  status,
  feedback,
  tooltipKey,
}) => {
  const [val, setVal] = useState(value);

  useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <LabelFieldWrapper>
      <TextWithTooltip as="span" $width={labelWidth}>
        {label}
        {tooltipKey && <AsoTooltip tooltipKey={tooltipKey} />}
      </TextWithTooltip>
      <Column $gap="0.25rem">
        <InputNumber100Px
          precision={precision}
          min={min}
          max={max}
          step={step}
          status={status}
          value={val}
          onChange={v => {
            const newValue = typeof v === 'number' ? v : null;
            onChange(newValue);
            setVal(newValue);
          }}
        />
        {feedback}
      </Column>
      {postfix}
    </LabelFieldWrapper>
  );
};
